import PharmacyBootGate from './PharmacyBootGate';

/** Require pharmacy session; wait for zustand persist hydrate without UI flash. */
export default function PharmacyAuthGuard({ children }) {
  return <PharmacyBootGate>{children}</PharmacyBootGate>;
}
